import Cookies from 'js-cookie';

import { clearMifState } from 'store/mif/mifSlice';
import { clearOrchestrateState } from 'store/orchestrate-signup/orchestrateSlice';
import {
  clearFirstAppointment,
  clearProviderState,
  clearUserState,
  setPromoVisited
} from 'store/signup/signupSlice';

import { useAppDispatch } from './index';

const useClearSignup = () => {
  const dispatch = useAppDispatch();
  return () => {
    dispatch(clearUserState());
    dispatch(clearMifState());
    dispatch(setPromoVisited(''));
    dispatch(clearProviderState());
    dispatch(clearFirstAppointment());
    dispatch(clearOrchestrateState());
    sessionStorage.removeItem('session-id');
    Cookies.remove('mifSentItems');
  };
};

export default useClearSignup;
